module.exports = __webpack_public_path__ + "img/xiting-logo.f7f3217e.png";